import { createAction } from '@reduxjs/toolkit'

import { movingAverage } from './reducer'

export const updateTimeFrame = createAction<{ timeframe: number }>('chart/updateTimeFrame')
export const updateChart = createAction<{ line: boolean }>('chart/updateChart')
export const addMovingAverage = createAction<movingAverage>('chart/addMovingAverage')
export const removeMovingAverage = createAction<{ type: string; number: number }>(
  'user/removeMovingAverage'
)
export const chartActive = createAction<{ active: boolean }>('chart/chartActive')
export const chartSize = createAction<{ width: number; height: number }>('chart/chartSize')
export const toLiquidity = createAction<boolean>('chart/toLiquidity')